<template>
	<div class="index h-full ">
		<van-nav-bar
			left-text="返回"
			left-arrow
			@click-left="back"
		/>
		<VideoPlayer v-if="courseInfo.video_file" :url="courseInfo.video_file" @play-start="handlePlayStart"
		             @play-end="handlePlayEnd"/>
		<div v-if="courseInfo.lesson_title" class="w-full lesson-title">
			{{ courseInfo.lesson_title }}
		</div>
        <van-loading v-if="isLoading" color="#1989fa" style="position: fixed; top:15%; left: 50%; transform: translate(-50%, -50%);"/>
		<div v-else class="q-a">
			<div v-if="courseInfo.question" class="q-a-context">
				<div class="q-a-context-title">有奖答题</div>
				<div class="q-a-context-diver"></div>
				<div v-for="(question,index1) in courseInfo.question" :key="'c_q_'+index1">
					<div class="q-a-context-topic layout-left-center" >
						<div class="layout-center q-a-context-topic-l" style="">单选题
						</div>
						{{ question.question_id }}.{{ question.question_title }}
					</div>
					<div v-for="(item,index) in question.question_option_json" :key="'item_'+index">
						<div class="q-a-context-option layout-left-center"
						     :class="[item.answer_checked==='1' ?'q-a-context-option-select':'']">
							<div>{{ String.fromCharCode(65 + index) }}</div>
							|
							<div style="position: relative">{{ item.option }}</div>
							<van-icon style="position: absolute;right: var(--base-px-36)" v-if="item.answer_checked==='1'"
							          name="success"/>
						</div>
					</div>
				</div>
			</div>
            <div v-else>
                <van-empty image="error" description="暂无课程数据"/>
            </div>
		</div>
	</div>
</template>
<script>
import {lessonDetails} from "@/api/course";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import VideoPlayer from "@/views/course/videoPlayer.vue";

export default {
	name: "courseDetails",
	components: {VideoPlayer},
	data() {
		return {
			courseInfo: {},
			selectOption: [],
			selectOptionNum: 0,
			player: null,
            isLoading:true
		}
	},
	created() {
		const {id} = this.$route.query
		lessonDetails({lesson_id: id + ""}).then(res => {
            if (res.code == 1) {
                console.log(res.data)
                this.selectOption = []
                res.data.question.forEach(q => {
                    this.selectOption.push({
                        option: ''
                    })
                    q.question_option_json = JSON.parse(q.question_option_json)
                })
                res.data.question.sort((a, b) => {
                    return a.question_id - b.question_id
                })
                this.courseInfo = res.data
                console.log(this.courseInfo);
            }

		}).finally(()=>{
            this.isLoading=false
        })
	},
	mounted() {

	},
	methods: {
		back() {
			this.$router.back()
		},
		onSelectOption(item) {
			this.selectOption = item
		},
		onSubmit() {
			console.log(this.courseInfo.question_option_json)
		},
		handlePlayStart() {
			console.log('视频开始播放');
			// 这里可以添加父组件的处理逻辑
		},
		handlePlayEnd() {
			console.log('视频播放结束');
			// 这里可以添加父组件的处理逻辑
		}
	}
}</script>
<style scoped lang="less">
.index {
	font-size: var(--base-px-14);
	min-height: 100%;
	background-color: #f2f3f7;
	width: 100%;

	.video-container {
		width: 100%;
		height: var(--base-px-214);
		margin: 0 auto;
	}

	button {
		background: transparent;
		color: white;
		border: none;
		padding: var(--base-px-8) var(--base-px-12);
		border-radius: var(--base-px-4);
		font-size: var(--base-px-16);
	}

	.lesson-title {
		font-weight: 400;
		font-size: var(--base-px-16);
		color: #666666;
		text-align: left;
		font-style: normal;
		text-transform: none;
		background: #FFFFFF;
		border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
		padding: var(--base-px-12);
	}

	.q-a {
		padding: var(--base-px-12);
	}

	.q-a-context {
		background: #FFFFFF;
		border-radius: var(--base-px-16) var(--base-px-16) var(--base-px-16) var(--base-px-16);
		padding: var(--base-px-16);

		&-title {
			font-weight: bold;
			font-size: var(--base-px-16);
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}

		&-diver {
			border: var(--base-px-1) solid #DBDBDB;
			margin-top: var(--base-px-12);
		}

		&-topic {
			padding-top: var(--base-px-12);
			font-weight: 400;
			font-size: var(--base-px-14);
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;

			&-l {
				height: var(--base-px-18);
				width: var(--base-px-53);
				background: #1A89F9;
				border-radius: var(--base-px-2) var(--base-px-10) var(--base-px-2) var(--base-px-10);
				font-size: var(--base-px-11);
				color: #FFFFFF;
			}
		}

		&-option {
			background: #F9F9F9;
			border-radius: var(--base-px-8);
			padding: 0 var(--base-px-16);
			height: var(--base-px-40);
			margin-top: var(--base-px-12);
			font-weight: 400;
			font-size: var(--base-px-14);
		}

		&-option-select {
			background: #1A89F9;
			color: #FFFFFF;
		}

		&-submit {
			margin-top: var(--base-px-32);
			width: var(--base-px-304);
			height: var(--base-px-64);
			border-radius: var(--base-px-16) var(--base-px-16) var(--base-px-16) var(--base-px-16);
			border: var(--base-px-2) solid #1A89F9;
			font-weight: 400;
			font-size: 28rpx;
			color: #1A89F9;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
	}

	.video-player {
		position: relative;
		width: 100%;
		background-color: #000;
	}

	video {
		width: 100%;
		display: block;
	}

	.controls {
		display: flex;
		align-items: center;
		padding: var(--base-px-8) var(--base-px-12);
		background-color: rgba(0, 0, 0, 0.7);
	}

	.control-btn {
		padding: var(--base-px-8);
		color: white;
		font-size: var(--base-px-18);
	}

	.progress-display {
		flex: 1;
		display: flex;
		align-items: center;
		margin: 0 var(--base-px-10);
		color: white;
		font-size: var(--base-px-12);
	}

	.progress-bar {
		flex: 1;
		height: var(--base-px-4);
		margin: 0 var(--base-px-10);
		background-color: rgba(255, 255, 255, 0.3);
		border-radius: var(--base-px-2);
		position: relative;
	}

	.progress {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background-color: #007aff;
		border-radius: var(--base-px-2);
	}
}
</style>
